import { Button, TextField } from "@mui/material";
import axios from "axios";
import { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { authData } from "../../components/GetAuth";
import styles from "./list.module.css";

const AddUserRoleForm = ({ setFormOpen, setAllData, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, editData }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;

  const { register, handleSubmit, control, setValue, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      name: "",
    },
  });

  useEffect(() => {
    if (editData) {
      setValue("name", editData?.name);
    }
  }, [editData, setValue]);

  const onSubmit = (data) => {
    setLoading(true);
    setFormOpen(false);

    if (editData) {
      axios.post(process.env.REACT_APP_API_URL + "v1/user-roles/" + editData?.id, data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            let temp = prev.map((i) => {
              if (i.id === editData?.id) {
                return response.data.data;
              }
              return i;
            });
            return temp;
          });
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    } else {
      axios.post(process.env.REACT_APP_API_URL + "v1/user-roles", data, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setLoading(false);
        if (response.data.status === "SUCCESS") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("success");
          setAllData((prev) => {
            return prev.concat([response.data.data]);
          });
        }
        if (response.data.status === "ERROR") {
          setSnackbarOpen(true);
          setSnackbarMessage(response.data.message);
          setSnackbarType("error");
        }
      }).catch((error) => {
        setLoading(false);
        if (error && error.response && error.response.data && error.response.data.messages) {
          setSnackbarOpen(true);
          setSnackbarMessage(error.response.data.messages);
          setSnackbarType("error");
        }
      });
    }
  };

  return (<>
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className={`${styles.FormMainRow}`}>
        <div className={`${styles.FormGroupFull} FormGroup`}>
          <Controller
            control={control}
            {...register("name", { required: "This field is Required" })}
            render={({ field }) => (<TextField {...field} label="Name*" variant="outlined" />)}
          />
          {errors.name && (<span className={`ErrorM`}>{errors?.name?.message}</span>)}
        </div>
      </div>
      <div className="ButtonAction">
        <Button className="CancelPopupBU" onClick={(e) => setFormOpen(false)}>Cancel</Button>
        <Button className="SubmitPopupBU" type="submit">{editData ? "Update" : "Add"}</Button>
      </div>
    </form>
  </>);
};

export default AddUserRoleForm;